import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useLottie } from 'lottie-react'
import explanations from '@/utils/lottie/explanations.json'
import './Tutorial.scss'

export default function Tutorial() {
  const { hasStarted } = useSelector((state) => state.progress)
  const { View, play, stop } = useLottie({
    animationData: explanations,
    loop: true,
  })

  useEffect(() => {
    let timeout

    if (hasStarted) {
      timeout = setTimeout(() => {
        play()
      }, 1000)
    } else {
      stop()
    }

    return () => {
      if (timeout) {
        clearTimeout(timeout)
        timeout = null
      }
    }
  }, [hasStarted, play, stop])

  return (
    <div className={`c-tutorial ${hasStarted ? '-has-started' : ''}`}>
      {View}
    </div>
  )
}
